export default __webpack_public_path__ + "static/mym-d2f25a984f6d69d7458b349e584fa86a.jpg";